<template>
    <div v-if="can('settings.returns-index')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Transportation organization')}}</a></router-link>
                <router-link to="/return-services" tag="li" class="breadcrumb-item"><a href="">{{i18n("Returns")}}</a>
                </router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl clearfix">
                <h1 class="title float-left pt-2">{{i18n("Returns")}}</h1>
                <button v-if="can('settings.returns-edit')" type="submit" class="btn base_btn solid_blue waves-effect waves-light float-right" @click="save()">{{i18n('Save and close')}}
                </button>
            </div>
        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <h5>{{i18n("Fault return")}}</h5>
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">{{i18n("Fault return")}}</th>
                                <th scope="col">{{i18n("Fine")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>АТП</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="0%" :class="{'is-invalid': form.errors.has('return_ticket_atp') }" v-model="form.return_ticket_atp"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('return_ticket_atp')">
                                        {{form.errors.get('return_ticket_atp')}}
                                    </div>
                                </td>


                            </tr>
                            <tr>
                                <td>{{i18n("Bus terminal")}}</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="0%" :class="{'is-invalid': form.errors.has('return_ticket_station') }" v-model="form.return_ticket_station"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('return_ticket_station')">
                                        {{form.errors.get('return_ticket_station')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>{{i18n("Passenger after flight departure")}}</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="25%" :class="{'is-invalid': form.errors.has('return_ticket_after') }" v-model="form.return_ticket_after"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('return_ticket_after')">
                                        {{form.errors.get('return_ticket_after')}}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5>{{i18n("The return of the fault of the passenger to the departure of the flight")}}</h5>
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col" class="w-50">За какое время</th>
                                <th scope="col">{{i18n("Fine")}}</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="model, key in return_ticket_before_options">
                                <td>

                                    <input type="text" class="form-control small_input" :class="{'is-invalid': form.errors.has('return_ticket_before.'+key+'.hour')}"
                                           v-model="model.hour" @keyup="handleRow(key)"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('return_ticket_before.'+key+'.hour')">
                                        {{form.errors.get('return_ticket_before.'+key+'.hour')}}
                                    </div>

                                </td>
                                <td>

                                    <input type="text" class="form-control small_input" :class="{'is-invalid': form.errors.has('return_ticket_before.'+key+'.percent')}"
                                           v-model="model.percent" @keyup="handleRow(key)"  @keypress="onlyNumber"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('return_ticket_before.'+key+'.percent')">
                                        {{form.errors.get('return_ticket_before.'+key+'.percent')}}
                                    </div>

                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormService from '../../services/FormService';
    export default {

        data() {
            return {
                form: new FormService({
                    return_ticket_atp: null,
                    return_ticket_station: null,
                    return_ticket_after: null,
                    return_ticket_before: [],
                }),
                return_ticket_before_options: [
                    {
                        hour: null,
                        percent: null,
                    }
                ],
                isFilled: false,
                returnSettingsError: [],
            }
        },

        methods: {
            save(){
                this.form.return_ticket_before = this.return_ticket_before_options;
                this.submitForm();
            },
            submitForm(){
                this.form.submit('post', this.route('api.return.store'))
                    .then(res => {
                        if (!res.errors) {
                            this.$router.push({name: 'return-services'});
                            this.$notify({
                                type: 'success',
                                group: 'foo',
                                title: 'Успешно!!!',
                                text: 'Сохранено!'
                            });
                        } else {
                            console.log(res.errors);
                        }
                    })
            },
            handleRow(key){
                let model = this.return_ticket_before_options;
                if(model.length > 0 &&
                    model[key].hour && model[key].hour.length > 0 &&
                    model[key].percent &&
                    model[key].percent.length > 0 &&
                    model.length === key + 1
                )
                    this.return_ticket_before_options.push({
                        hour: null,
                        percent: null
                    });

                if(model.length > 1 && !model[key].hour && !model[key].percent) {
                    model.splice(key + 1, 1);
                    model.splice(key, 1);
                }
            },
            onlyNumber ($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                    $event.preventDefault();
                }
            },
            fillForm(data){
                this.form.return_ticket_atp = data.return_ticket_atp;
                this.form.return_ticket_station = data.return_ticket_station;
                this.form.return_ticket_after = data.return_ticket_after;
                this.return_ticket_before_options = JSON.parse(data.return_ticket_before) ? JSON.parse(data.return_ticket_before) : this.return_ticket_before_options;
            },
        },

        created() {
            this.$api.get('return.index')
                .then(res => {
                    this.fillForm(res.data);
                });

            console.log(this.return_ticket_before_options.length);
        },

    }
</script>

<style></style>
